//加载汉子package
import Tools from '@hanzi-package/tools';
// 加载必要的文件
import '@static/flexible.js';
// import '@static/video.min.js';
import 'vant/lib/index.css';
import Promise, { resolve } from 'bluebird';
import { Alert, Log, Route } from 'hanzi-mobile-package';
import $ from 'jquery';
//弹出框类
import { Indicator, MessageBox, Toast } from 'mint-ui';
// import '../static/layim/dist/css/layui.mobile.css';
//underscore
import _ from 'underscore';
import Vue from 'vue';
import VueRouter from 'vue-router';
//vue-ydui
import 'vue-ydui/dist/ydui.base.css';
import Config from '../.config.js';
import App from './App';
// import '../static/navigation.js';
import './assets/sass/common/base.scss';
import comApp from './common/app';
import LoginStatus from './common/loginStatus';
//加载错误操作设置
import ErrorData from './error_handle.js';
// import '@static/layui.layim-v3.7.3/src/layui.js';
//加载本地路由
import BaseRoute from './routes/base';
import DynamicRoute from './routes/dynamic';
import ExampleRoute from './routes/example';
//不需要登录的页面
import NologinRoute from './routes/nologin';
import SystemRoute from './routes/system';
import store from './store/index';

import baseKeyboard from 'components/Keyboard.vue';
Vue.component(baseKeyboard.name, baseKeyboard);



var messageBox = MessageBox;
var toast = Toast;
var indicator = Indicator;
Alert.ui.messageBox = messageBox;
Alert.ui.toast = toast;
Alert.ui.indicator = indicator;



var tools = Tools;
var log = Log;
var alert = Alert;
var loginStatus = LoginStatus;

//定义错误操作数组
tools.errorData = ErrorData.data;
tools.loginStatus = loginStatus;

//underscore
tools._ = _;

//初始化路由
Route.data.baseRoute = BaseRoute;
Route.data.dynamicRoute = DynamicRoute;
Route.data.systemRoute = SystemRoute;
Route.data.exampleRoute = ExampleRoute;

var app = window;

Tools.vue = Vue;
Tools.alert = alert;

app.tools = tools;
app.config = Config;
app.log = log;
app.Promise = Promise;
app.app = comApp;

Vue.use(VueRouter);

//定义是否可以初始化签名
app.canauthinit = 1;

/* 定义路由 */
const routes = Route.routes();
const router = new VueRouter({
  mode: 'history',
  routes
});
//记录刚进页面时的链接，ios用到
tools.cache.set('initUrl', location.href);

if (/(^\/distribution\/(chat))/.test(location.pathname)) {
  window.wx = null;
  $('#weixin').remove();
  tools.url.params('token') ? tools.cache.set('Authorization', tools.url.params('token')) : '';
}
tools.url.params('token') ? tools.cache.set('Authorization', tools.url.params('token')) : '';
/* 初次打开,检查权限 */
router.beforeEach((to, from, next) => {
  if(to.path === '/download'||to.path=='/distribution/activity/tickets/tickets_qrcode'){
    next();
  }else{
   next('/download')
  }
  // if(JSON.parse(tools.cache.get('loginData'))&&JSON.parse(tools.cache.get('loginData')).is_maintenance==1){
  //   if(to.path === '/download'){
  //     next();
  //   }else{
  //    next('/download')
  //   }
  // }else{
  //   if (to.path === '/download') {
  //     next();
  //   } else if (to.path === '/update') {
  //     next();
  //   } else {
  //     LoginStatus.checkLogin({
  //       type: 'wechatOauth', // wechatOauth, login
  //       redirectUrl: '/api/wechat/auth', //验证不通过跳转的地址
  //       url: to.path, //需要验证的地址
  //       callbackUrl: to.fullPath, //返回的地址
  //       to
  //     }, next);
  // }
  // }
});

/* 定义路由示例 */
app.tools.router = router;

/* 定义路由数组 */
app.tools.routes = routes;

//不需要登录的页面
tools.noLoginUrl = NologinRoute;

// 定义指令
const windowHeight = window.innerHeight
Vue.directive('fixedInput', function(el, binding) {
  el.addEventListener('blur', function() {
    let windowFocusHeight = window.innerHeight
    if (windowHeight == windowFocusHeight) {
      return
    }
    let currentPosition;
    let speed = 1; //页面滚动距离
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
    setTimeout(() => {
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    }, 10);
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  store
});



// WEBPACK FOOTER //
// ./src/main.js